import React, { useState } from 'react';
import {
  LabelledMultiLangInputProps,
  MultilangFormEditData,
  MultiLangInput,
  MultiLangTextarea,
} from '@carlito/dashboard-ui';
import { KeyboardType, useScreenKeyboard } from './useScreenKeyboard';
import { KeyBoard } from '../KeyBoard/KeyBoard';
import { useFormikContext } from 'formik';
import { isMultiLangContent } from '@carlito/intl';
import './keyboard.css';

type Props = LabelledMultiLangInputProps & {
  enabledKeyboard?: boolean;
  keyboardType?: KeyboardType;
  canChangeKeyboardType?: boolean;
};

function TextInputWithKeyboard({
  keyboardType: defaultKeyboardType,
  canChangeKeyboardType,
  enabledKeyboard,
  name,
  ...rest
}: Props) {
  const { values, getFieldProps, setFieldValue, setFieldTouched, status } =
    useFormikContext<MultilangFormEditData<any>>();

  const [isFocused, setIsFocused] = useState(false);
  const { value, onChange } = getFieldProps(name);

  const { keyboardType, handleKeyPress, handleSetFocus } = useScreenKeyboard({
    defaultKeyboardType,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      if (isMultiLangContent(value)) {
        setFieldValue(name, {
          ...value,
          values: {
            ...value.values,
            [values.activeLanguage]: e.target.value,
          },
        });
        return;
      }
      setFieldTouched(name, true);

      onChange(e);
      rest?.onChange?.(e);
    },
  });

  return (
    <React.Fragment>
      <MultiLangInput
        readOnly={enabledKeyboard} // prevent mobile keyboard from opening
        name={name}
        onFocus={(e: any) => {
          if (!enabledKeyboard) return;
          setIsFocused(true);
          handleSetFocus(e.target);
        }}
        onBlur={(e: any) => {
          setIsFocused(false);
          rest?.onBlur?.(e);
        }}
        {...rest}
      />
      {isFocused && (
        <KeyBoard
          canChangeKeyboardType={canChangeKeyboardType}
          handleKeyPress={handleKeyPress}
          keyboardType={keyboardType}
        />
      )}
    </React.Fragment>
  );
}

export default TextInputWithKeyboard;
